import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
@Component({
  selector: 'dgx-hero-image',
  templateUrl: './hero-image.component.html',
  styleUrls: ['./hero-image.scss'],
})
export class HeroImageComponent implements OnChanges {
  @Input() public imageSrc: string;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageSrc && this.imageSrc) {
      this.imageSrc = 'https://img.degreed.com/image/fetch/' + this.imageSrc;
    }
  }
}
